module.exports = __webpack_public_path__ + "static/media/Bb7.c150a9e8.mp3";